import React from 'react';
import './services.css';
import { useDispatch, useSelector } from "react-redux";
import ServiceForm from "../ServiceForm/ServiceForm";
import { setServiceFormAction } from "../../redux/rootReducer";
import { SERVICE_FORM_INITIAL } from "../../redux/initialStateConstant";
import { GetServiceByIdThunk } from "../../redux/thunks/GetServiceByIdThunk";
import { RemoveServiceThunk } from "../../redux/thunks/RemoveServiceThunk";
import MasterServicesForm from "../MasterServicesForm/MasterServicesForm";
import { GetMasterServicesThunk } from "../../redux/thunks/GetMasterServicesThunk";

const Services = () => {
    const dispatch = useDispatch();
    const services_settings = useSelector(state => state.services_settings);
    const service_form = useSelector(state => state.service_form);
    const master_services_form = useSelector(state => state.master_services_form);

    return (
        <>
            { service_form.open && <ServiceForm/> }
            { master_services_form.open && <MasterServicesForm/> }
            <div className="services_settings services_settings--services">
                <div className="services_settings__header services_settings__header--services">
                    <div className="services_settings__add button button--blue"
                         onClick={ () => {
                             dispatch(setServiceFormAction({
                                 ...SERVICE_FORM_INITIAL,
                                 open: true
                             }));
                         } }
                    >Добавить услугу</div>
                </div>
                {
                    services_settings.services.length > 0
                        ?
                        <div className="table">
                            <div className="table__row table__row--header table__row--services">
                                <div className="table__cell">№</div>
                                <div className="table__cell">Услуга</div>
                                <div className="table__cell">Специализация</div>
                                <div className="table__cell">Длетельность</div>
                                <div className="table__cell">Стоимость</div>
                                <div className="table__cell"/>
                                <div className="table__cell"/>
                                <div className="table__cell"/>
                            </div>
                            {
                                services_settings.services.map((elem, index) => {
                                    return (
                                        <div className="table__row table__row--services" key={ elem.id }>
                                            <div className="table__cell">{ index + 1}</div>
                                            <div className="table__cell">{ elem.name }</div>
                                            <div className="table__cell">{ elem.specialization }</div>
                                            <div className="table__cell">{ elem.duration }</div>
                                            <div className="table__cell">{ elem.price }</div>
                                            <div className="table__cell table__cell--no-overflow">
                                                <div className="control control--masters"
                                                    onClick={ () => {
                                                        dispatch(GetMasterServicesThunk({
                                                            service_id: elem.id
                                                        }));
                                                    } }
                                                />
                                            </div>
                                            <div className="table__cell table__cell--no-overflow">
                                                <div className="control control--edit"
                                                     onClick={ () => {
                                                         dispatch(GetServiceByIdThunk({
                                                             service_id: elem.id
                                                         }));
                                                     } }
                                                />
                                            </div>
                                            <div className="table__cell table__cell--no-overflow">
                                                <div className="control control--remove"
                                                     onClick={ () => {
                                                         if (!window.confirm('Вы действительно хотите удалить услугу?')) return;

                                                         dispatch(RemoveServiceThunk({
                                                             service_id: elem.id
                                                         }));
                                                     } }
                                                />
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                        :
                        <div className="empty__list">Нет сохранённых услуг</div>
                }
            </div>
        </>
    );
};

export default Services;